import { updateBusinessAccountBankDetailsArgs } from 'types/api/arguments/update-business-account-bank-details-args'

import { api } from './api'

export const updateBusinessAccountBankDetails = ({
  bankAccountOwnerName,
  bankAccountNumber,
}: updateBusinessAccountBankDetailsArgs) =>
  api.put('/business_accounts_dsa', {
    bank_account_number: bankAccountNumber,
    bank_account_owner_name: bankAccountOwnerName,
  })
